import { TWO_FACTOR } from '../../actions/twoFactor';

const twofactor = (state = {}, action = {}) => {
  const { type = '', payload = {} } = action;
  switch (type) {
    case TWO_FACTOR.OPEN:
      return {
        ...state,
        isVisible: true,
        payload,
      };
    case TWO_FACTOR.CLOSE:
      return {
        ...state,
        isVisible: false,
      };
    default:
      return state;
  }
};

export default twofactor;
